import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface OnlinePresenceScreenProps {
  website: string;
  socialMedia: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function OnlinePresenceScreen({
  website,
  socialMedia,
  onChange,
  onNext,
  onBack
}: OnlinePresenceScreenProps) {
  // Optional fields, so always valid to proceed
  const isValid = true;
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-217">
      <div className="flex-1" data-id="element-218">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-219">
          Online Presence
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-220">
          Where can we find your business online? (Optional)
        </p>

        <div className="space-y-6" data-id="element-221">
          <Input label="Website URL" placeholder="https://www.example.com" value={website} onChange={e => onChange('website', e.target.value)} autoFocus data-id="element-222" />
          <Input label="Social Media Link" placeholder="LinkedIn, Facebook, or Instagram profile" value={socialMedia} onChange={e => onChange('socialMedia', e.target.value)} data-id="element-223" />
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-224">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-225">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-226">
          Continue
        </Button>
      </div>
    </div>;
}